import { defineComponent as u, ref as p, onMounted as c, watch as l, nextTick as f, openBlock as i, createElementBlock as d } from "vue";
import { CountUp as m } from "countup.js";
const w = /* @__PURE__ */ u({
  name: "e-count-up",
  __name: "count-up",
  props: {
    startValue: { default: 0 },
    endValue: {},
    options: {},
    recreate: { type: Boolean }
  },
  setup(o, { expose: s }) {
    const t = o, r = p();
    let e;
    const n = (a) => {
      r.value && (e = new m(r.value, +t.endValue, {
        ...t.options,
        startVal: +t.startValue
      }), a && e.start());
    };
    return c(() => {
      n(!0);
    }), l([() => t.endValue, () => t.startValue], (a) => {
      t.recreate ? n(!1) : e.update(a[0]);
    }), s({
      update: (a) => {
        e.update(a);
      },
      start: () => {
        e.start();
      },
      restart: () => {
        f(() => {
          e.reset(), e.start();
        });
      }
    }), (a, V) => (i(), d("div", {
      ref_key: "wrapper",
      ref: r,
      class: "e-count-up"
    }, null, 512));
  }
});
export {
  w as default
};
//# sourceMappingURL=count-up.js.map
